import { cn, getInitials } from '@bliks-io/ui';

interface PersonChipProps {
  name: string;
  /** Secondary line under the name (e.g. the person's role) */
  subline?: string;
  size?: 22 | 28;
  className?: string;
}

/**
 * Compact person representation from the onboarding design: initials
 * avatar + name, optionally with a muted role sub-line.
 */
export function PersonChip({ name, subline, size = 22, className }: PersonChipProps) {
  return (
    <div className={cn('flex min-w-0 items-center', size === 28 ? 'gap-2.25' : 'gap-2', className)}>
      <span
        className={cn(
          'flex shrink-0 items-center justify-center rounded-full bg-surface-strong font-bold text-fg-secondary',
          size === 28 ? 'h-7 w-7 text-2xs' : 'h-[22px] w-[22px] text-[9px]'
        )}
      >
        {getInitials(name)}
      </span>
      <div className="min-w-0">
        <div
          className={cn(
            'truncate font-semibold text-foreground',
            size === 28 ? 'text-[13px]' : 'text-[12.5px]'
          )}
        >
          {name}
        </div>
        {subline && <div className="truncate text-2xs text-fg-subtle">{subline}</div>}
      </div>
    </div>
  );
}
